<div
    class="folder"
    style="height: 100%"
    fxLayout="row"
    fxLayoutAlign="start center"
>
    <!-- <div class="icon unselectable" fxFlex="10"> -->
    <div class="folder-icon icon unselectable">
        <mat-icon class="dms-folder-icon" [style.color]="Folder.Color"
            >folder</mat-icon
        >
    </div>
    <!-- <div
        fxFlex="70"
        class="document-title text-truncate unselectable"
        [ngClass]="{ 'selected-text': Selected }"
    > -->
    <div
        class="document-title text-truncate unselectable"
        [ngClass]="{ 'selected-text': Selected }"
    >
        <!-- {{ Folder?.Name.length > 24 ? (Folder?.Name | slice: 0:24) + ".." : Folder?.Name }} -->
        {{ Folder?.Name }}
    </div>

    <div fxLayout="row" fxLayoutAlign="end center" fxFlex="10">
        <mat-icon
            *ngIf="
                Folder.SharedByUserName &&
                dmsConfig.viewSharedDoc &&
                !dmsConfig.viewMyDoc
            "
            class="mt-4"
            style="color: rgba(0, 0, 0, 0.6); z-index: 99 !important"
            matTooltip="Shared by: {{ Folder.SharedByUserName }}"
            >info</mat-icon
        >
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="end center" fxFlex="10" *ngIf="Folder.Type === 'DriveFolder' || dmsConfig.actionOnShared">
        <button mat-icon-button type="button" class="" [matMenuTriggerFor]="actionMsddenu"
            (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
        </button>
    </div> -->
</div>
<!-- 
<mat-menu #actionMsddenu="matMenu">
    <div>
        <menu
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            class="m-0"
            (click)="share(Folder)"
            *ngIf="
                (Folder.Type === 'DriveFolder' || dmsConfig.actionOnShared) &&
                !dmsConfig.viewArchivedDoc
            "
        >
            <mat-icon class="material-icons mr-12">share</mat-icon>
            <span>{{
                'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SHARE' | translate
            }}</span>
        </menu>
        <mat-divider
            *ngIf="
                (Folder.Type === 'DriveFolder' || dmsConfig.actionOnShared) &&
                !dmsConfig.viewArchivedDoc &&
                !isPayrollDoc
            "
        ></mat-divider>
    </div>
    <div>
        <menu
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            class="m-0"
            (click)="rename(Folder)"
            *ngIf="
                (Folder.Type === 'DriveFolder' || dmsConfig.actionOnShared) &&
                !dmsConfig.viewArchivedDoc &&
                !isPayrollDoc
            "
        >
            <mat-icon class="material-icons mr-12">edit</mat-icon>
            <span>{{
                'APP_PLATFORM_DOCUMENT_MANAGER.DMS_RENAME' | translate
            }}</span>
        </menu>
    </div>
    <div>
        <menu
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            class="m-0"
            (click)="remove(Folder)"
            *ngIf="
                dmsConfig.actionOnShared &&
                !dmsConfig.viewArchivedDoc &&
                !isPayrollDoc
            "
            [disabled]="forbiddenIdsToDelete.includes(Folder.ItemId)"
        >
            <mat-icon class="material-icons mr-12">delete</mat-icon>
            <span>{{ 'Delete' | translate }}</span>
        </menu>
        <menu
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            class="m-0"
            (click)="archive(Folder)"
            *ngIf="
                Folder.Type === 'DriveFolder' &&
                !dmsConfig.actionOnShared &&
                !dmsConfig.viewArchivedDoc &&
                !isPayrollDoc
            "
            [disabled]="forbiddenIdsToDelete.includes(Folder.ItemId)"
        >
            <mat-icon class="material-icons mr-12">archive</mat-icon>
            <span>{{ 'Add to Archive' | translate }}</span>
        </menu>
        <menu
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            class="m-0"
            (click)="unarchive(Folder)"
            *ngIf="
                Folder.Type === 'DriveFolder' &&
                !dmsConfig.actionOnShared &&
                dmsConfig.viewArchivedDoc
            "
            [disabled]="forbiddenIdsToDelete.includes(Folder.ItemId)"
        >
            <mat-icon class="material-icons mr-12">unarchive</mat-icon>
            <span>{{ 'Unarchive' | translate }}</span>
        </menu>
    </div>
</mat-menu> -->
